/* impressed: autoplay for product carousels (Apple-like calm motion) */
(function () {
  var AUTOPLAY_MS = 5500; /* luxury pacing: slow, deliberate */
  var RESUME_AFTER_INTERACT_MS = 8000;
  var SCROLL_RESTORE_MS = 700;

  function initAutoplay() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sliders = document.querySelectorAll('.collection slider-component .slider');
    sliders.forEach(function (slider) {
      var component = slider.closest('slider-component');
      var slides = slider.querySelectorAll('[id^="Slide-"]');
      if (!component || slides.length < 2) return;

      var timer = null;
      var userHoldUntil = 0;
      var programmatic = false;

      function step() {
        var w = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
        return w + gap;
      }
      function smoothTo(left) {
        programmatic = true;
        slider.style.scrollSnapType = 'none';
        slider.style.scrollBehavior = 'smooth';
        slider.scrollTo({ left: left, behavior: 'smooth' });
        setTimeout(function () {
          slider.style.scrollSnapType = '';
          slider.style.scrollBehavior = '';
          programmatic = false;
        }, SCROLL_RESTORE_MS);
      }
      function advance() {
        if (programmatic || Date.now() < userHoldUntil || document.hidden) return;
        var max = slider.scrollWidth - slider.clientWidth - 8;
        var target = slider.scrollLeft + step();
        if (target >= max) target = 0;
        smoothTo(target);
      }
      function start() { stop(); timer = setInterval(advance, AUTOPLAY_MS); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function hold(ms) { userHoldUntil = Date.now() + ms; }

      slider.addEventListener('pointerenter', function () { hold(3600000); });
      slider.addEventListener('pointerleave', function () { hold(1500); });
      slider.addEventListener('touchstart', function () { hold(3600000); }, { passive: true });
      slider.addEventListener('touchend', function () { hold(4000); }, { passive: true });
      ['previous', 'next'].forEach(function (name) {
        var btn = component.querySelector('button[name="' + name + '"]');
        if (btn) btn.addEventListener('click', function () { hold(RESUME_AFTER_INTERACT_MS); });
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.15 });
      io.observe(slider);
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoplay);
  } else {
    initAutoplay();
  }
})();

